<template>
  <div id="menu-vsc">
    <div class="w-100" style="height: var(--safe-area-inset-top)"></div>
    <div class="text-center">
      <img src="@/assets/images/logos/virtual-shopping-club.webp" alt="" style="max-width: 90%">
    </div>
    <div class="row text-center fg-white mt-3 mx-2" style="row-gap: 8px">
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'menu_principal'})">
          Inicio
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'inicio'})">
          Mi Cuenta
        </div>
      </div>
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'conecta'})">
          Recargas y servicios
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'tarjeta_alianza'})">
          Saldo Alianza
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'saldo'})">
          Saldo Publicitario
        </div>
      </div>
      <div class="cell-fs-full">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0"
             @click="safeRoutePush({name: 'home_ds'})">
          Marketplace
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'codigos-registro'})">
          Códigos
        </div>
      </div>
      <div class="cell-fs-6">
        <div class="shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer m-0 h-100 d-flex
                    flex-justify-center flex-align-center"
             @click="safeRoutePush({name: 'red'})">
          Mi red
        </div>
      </div>
      <div class="cell-fs-full" id="switch-menu">
        <img class="border border-radius-20 bd-k10blue border-size-2 p-2 c-pointer w-50"
             src="@/assets/images/logos/koinonia10.webp" alt="" @click="$emit('switch-menu')">
      </div>
    </div>
    <div class="mt-10 mx-4 border bd-lightBlue fg-darkBlue">
      <div data-role="accordion" data-one-frame="false" data-material="true">
        <div class="frame">
          <div class="heading"><span class="text-secondary">Avisos de privacidad y términos</span></div>
          <div class="content py-0">
            <div class="c-pointer p-1 text-small highlight" v-for="doc in documents"
                 :key="`document-option-${doc.slug}`"
                 @click="safeRoutePush({name: 'help', params: {slug: doc.slug}})">
              {{ doc.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "menu-vsc",
  computed: {
    documents() {
      return this.$store.getters.helpGeneral
    }
  },
  methods: {
    safeRoutePush(route) {
      let differentRoute = this.$route.name !== route.name
      if (!differentRoute) {
        //Comparar params
        const keysParamsDest = route.params ? Object.keys(route.params) : []
        const keysParamsSrc = Object.keys(this.$route.params)
        differentRoute = keysParamsDest.length !== keysParamsSrc.length
        if (!differentRoute && keysParamsDest.length > 0) {
          const uniqueKeys = [...new Set(keysParamsDest.concat(keysParamsSrc))]
          for (const key of uniqueKeys) {
            differentRoute = this.$route.params[key] !== route.params[key]
            if (differentRoute) {
              break
            }
          }
        }
      }
      if (differentRoute) {
        this.$router.push(route).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.options-gradient {
  background: #FF6347;
  background: linear-gradient(135deg, rgba(255, 99, 71, 1) 0%, rgba(255, 165, 0, 1) 100%);
}
@media (min-width: 1236px) {
  #switch-menu {
    display: none;
  }
}
</style>